export const LoanContactTypeEnum = {
  Borrower1: 'Borrower1',
  Borrower2: 'Borrower2',
  Borrower3: 'Borrower3',
  Borrower4: 'Borrower4',
  Realtor: 'Realtor',
  LoanRole: 'LoanRole',
  SystemAddress: 'SystemAddress',
  NonBorrowingEntities: 'NonBorrowingEntities',
  SellingAgents: 'SellingAgents',
  ListingAgents: 'ListingAgents',
  Sellers: 'Sellers',
  NonBorrowerEntity1: 'NonBorrowerEntity1',
  NonBorrowerEntity2: 'NonBorrowerEntity2',
  NonBorrowerEntity3: 'NonBorrowerEntity3',
  NonBorrowerEntity4: 'NonBorrowerEntity4',
  VestedIndividual1: 'VestedIndividual1',
  VestedIndividual2: 'VestedIndividual2',
  VestedIndividual3: 'VestedIndividual3',
  VestedIndividual4: 'VestedIndividual4',
  SecurityGroup: 'SecurityGroup',
  TitleCompanyContact: 'TitleCompanyContact',
};
